import { createAction, props } from '@ngrx/store';

import {
  BusinessProfileProvider,
  BusinessProfileSyncResult,
  ExternalBusinessProfile,
  ExternalBusinessProfileAccount,
  SetAdsLabelEnabledResult,
  TransferProfileResult,
} from './business-profiles.models';

// Account actions
export const loadAccounts = createAction('[BusinessProfiles] Load Accounts');

export const loadAccountsSuccess = createAction(
  '[BusinessProfiles] Load Accounts Success',
  props<{ accounts: ExternalBusinessProfileAccount[] }>(),
);

export const loadAccountsFailure = createAction(
  '[BusinessProfiles] Load Accounts Failure',
  props<{ error: unknown }>(),
);

export const seedAccounts = createAction('[BusinessProfiles] Seed Accounts');

export const seedAccountsSuccess = createAction(
  '[BusinessProfiles] Seed Accounts Success',
  props<{ accounts: ExternalBusinessProfileAccount[] }>(),
);

export const seedAccountsFailure = createAction(
  '[BusinessProfiles] Seed Accounts Failure',
  props<{ error: unknown }>(),
);

// Profile actions
export const createBusinessProfile = createAction(
  '[BusinessProfiles] Create Business Profile',
  props<{ shopId: string; provider: BusinessProfileProvider; accountId: string }>(),
);

export const createBusinessProfileSuccess = createAction(
  '[BusinessProfiles] Create Business Profile Success',
  props<{ profile: ExternalBusinessProfile }>(),
);

export const createBusinessProfileFailure = createAction(
  '[BusinessProfiles] Create Business Profile Failure',
  props<{ error: unknown }>(),
);

export const loadBusinessProfilesForShop = createAction(
  '[BusinessProfiles] Load Business Profiles For Shop',
  props<{ shopId: string }>(),
);

export const loadBusinessProfilesForShopSuccess = createAction(
  '[BusinessProfiles] Load Business Profiles For Shop Success',
  props<{ profiles: ExternalBusinessProfile[] }>(),
);

export const loadBusinessProfilesForShopFailure = createAction(
  '[BusinessProfiles] Load Business Profiles For Shop Failure',
  props<{ error: unknown }>(),
);

export const syncBusinessProfile = createAction(
  '[BusinessProfiles] Sync Business Profile',
  props<{ profileId: string }>(),
);

export const syncBusinessProfileSuccess = createAction(
  '[BusinessProfiles] Sync Business Profile Success',
  props<{ result: BusinessProfileSyncResult }>(),
);

export const syncBusinessProfileFailure = createAction(
  '[BusinessProfiles] Sync Business Profile Failure',
  props<{ error: unknown }>(),
);

export const pushBusinessProfile = createAction(
  '[BusinessProfiles] Push Business Profile',
  props<{ profileId: string }>(),
);

export const pushBusinessProfileSuccess = createAction(
  '[BusinessProfiles] Push Business Profile Success',
  props<{ result: BusinessProfileSyncResult }>(),
);

export const pushBusinessProfileFailure = createAction(
  '[BusinessProfiles] Push Business Profile Failure',
  props<{ error: unknown }>(),
);

export const loadAllProfiles = createAction('[BusinessProfiles] Load All Profiles');

export const loadAllProfilesSuccess = createAction(
  '[BusinessProfiles] Load All Profiles Success',
  props<{ profiles: ExternalBusinessProfile[] }>(),
);

export const loadAllProfilesFailure = createAction(
  '[BusinessProfiles] Load All Profiles Failure',
  props<{ error: unknown }>(),
);

export const syncAllProfiles = createAction('[BusinessProfiles] Sync All Profiles');

export const syncAllProfilesSuccess = createAction(
  '[BusinessProfiles] Sync All Profiles Success',
  props<{ profiles: ExternalBusinessProfile[] }>(),
);

export const syncAllProfilesFailure = createAction(
  '[BusinessProfiles] Sync All Profiles Failure',
  props<{ error: unknown }>(),
);

// Ads label actions (AM-4655) — admin-only
export const setAdsLabelEnabled = createAction(
  '[BusinessProfiles] Set Ads Label Enabled',
  props<{ shopId: string; enabled: boolean }>(),
);

export const setAdsLabelEnabledSuccess = createAction(
  '[BusinessProfiles] Set Ads Label Enabled Success',
  props<{ result: SetAdsLabelEnabledResult }>(),
);

export const setAdsLabelEnabledFailure = createAction(
  '[BusinessProfiles] Set Ads Label Enabled Failure',
  props<{ shopId: string; error: unknown }>(),
);

// Transfer actions (AM-4739) — admin-only
export const transferProfile = createAction(
  '[BusinessProfiles] Transfer Profile',
  props<{ profileId: string; shopId: string }>(),
);

export const transferProfileSuccess = createAction(
  '[BusinessProfiles] Transfer Profile Success',
  props<{ result: TransferProfileResult }>(),
);

export const transferProfileFailure = createAction(
  '[BusinessProfiles] Transfer Profile Failure',
  props<{ profileId: string; error: unknown }>(),
);

export const clearTransferResult = createAction('[BusinessProfiles] Clear Transfer Result');

export const clearBusinessProfilesState = createAction('[BusinessProfiles] Clear State');
